const { lock, unlock } = require('tua-body-scroll-lock');
const { isIOSUserAgent } = require('../common/utils/device');
const { loadAssetsFromObject } = require('../common/utils/dom');
const getAnalyticsEventCenter = require('../common/getAnalyticsEventCenter');

const analyticsEventCenter = getAnalyticsEventCenter();

const TUA_BODY_SCROLL_ACTIONS = {
  lock: 0,
  unlock: 1,
};

const closeElement = `<!-- Modal actions -->
<div class="modal-actions">
  <button class="btn-close modal-close-action">
    <span class="visually-hidden">close</span>
  </button>
</div>`;

let useVeil = false;

/**
 * Applies the specified IOS scroll fix to the specified component and its childs
 * @param {Element} trigger Element which triggers the modal opening
 */
function applyScrollFix(modal, action = TUA_BODY_SCROLL_ACTIONS.lock) {
  if (isIOSUserAgent()) {
    // Get the modal body component and all its scrollable childs (needs to have the article__overflow class)
    const scrollableElements = Array.from(modal.querySelectorAll('.modal-body, .article__overflow'));
    if (action === TUA_BODY_SCROLL_ACTIONS.lock) {
      lock(scrollableElements);
    } else if (action === TUA_BODY_SCROLL_ACTIONS.unlock) {
      unlock(scrollableElements);
    }
  }
}

/**
 * Creates data object to be passed to the method that creates the modal
 * @param {Element} trigger Element which triggers the modal opening
 */
function createModalData(trigger) {
  const urlContent = $(trigger).data('modal-content-url') || $(trigger).attr('href');
  const modalType = $(trigger).data('modal-type');
  const closeHTML = $(trigger).data('modal-close') ? closeElement : '';

  useVeil = !!$(trigger).data('modal-veil');

  const data = {
    urlContent,
    modalType,
    closeHTML,
  };
  createModal(data);
}

/**
 * Load content from data object url into a new modal window
 */
function createModal(data) {
  // first we make sure we have no modals open
  if ($('.modal').length !== 0) {
    closeAllModals();
  }

  const {
    urlContent,
    modalType,
    closeHTML,
  } = data;

  const htmlString = `
    <div class="modal" data-modal-type="${modalType}" role="dialog" style="display: block;">
      <div class="modal-dialog">
        <div class="modal-content-wrapper">
          ${closeHTML}
          <!-- Modal content -->
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title"></h4>
            </div>
            <div class="modal-body"></div>
            <div class="modal-footer"></div>
          </div>
        </div>
      </div>
    </div>`;

  const $modal = $(htmlString);
  $modal.appendTo('body');
  if (useVeil) {
    $.spinner().start();
  }

  loadModalContent($modal, urlContent);

  $('.btn-close', $modal).on('click', handleClickToClose);
  $('.veil .underlay').on('click', closeAllModals);
}

/**
 * Fix fade modals behaviour
 */
function fixFadeBackdrop() {
  document.querySelector('.modal-backdrop:not(.fade)')?.remove();
  document.querySelector('.modal-backdrop.fade')?.classList.add('fade-visible');
}

/**
 * Create and initialize a bootstrap modal from custom html code
 * @param {string} htmlCode html code to use in the modal
 * @param {Object} [modalOptions] modal bootstrap options
 * @param {Object} [includeAssets] js and css assets to dinamically include
 */
function createCustomModal(htmlCode, modalOptions, includeAssets) {
  if (htmlCode) {
    closeAllModals();

    // Overwrite unnecessary body padding-right put by bootstrap
    document.body.classList.add('modal-fix');
    document.body.insertAdjacentHTML('beforeend', htmlCode);

    if (includeAssets) {
      loadAssetsFromObject(includeAssets);
    }

    const $createdModal = $('body > .modal:last-of-type');

    $createdModal.on('shown.bs.modal', () => {
      const modalBackdrop = document.querySelector('.modal-backdrop');
      // Scroll IOS fix
      if (modalBackdrop) {
        applyScrollFix($createdModal[0]);
        $createdModal.on('hide.bs.modal', () => {
          applyScrollFix($createdModal[0], TUA_BODY_SCROLL_ACTIONS.unlock);
        });
      }
      // Fix for fade modals -> Two backdrops were created due to jQuery + Bootrap version problems
      if ($createdModal.hasClass('fade')) {
        fixFadeBackdrop();
      }
      // Send info for Analytics
      if ($createdModal.attr('id') === 'addressSuggestion'
        && document.body.classList.contains('page--checkout')) {
        analyticsEventCenter.publish(
          analyticsEventCenter.EVENTS.modalVertexSuggestedAddressOpened,
        );
      } else if ($createdModal.attr('id') === 'errorModal'
        && document.body.classList.contains('page--checkout')) {
        analyticsEventCenter.publish(
          analyticsEventCenter.EVENTS.modalVertexInvalidAddressOpened,
        );
      }
    });

    $createdModal.on('hide.bs.modal', () => {
      closeModal($createdModal);
    });

    if (modalOptions) {
      $createdModal.modal(modalOptions);
    } else {
      $createdModal.modal();
    }

    // Use data-dismiss instead
    // $('.btn-close', $createdModal).on('click', handleClickToClose);
  }
}

function loadModalContent($modal, urlToContent) {
  $.get(urlToContent, (response) => {
    if (response.success) {
      $('.modal-body', $modal).html($.parseHTML(response.content));
      $modal.addClass('show');
      applyScrollFix($modal[0]);
    } else if (response.error) {
      closeModal($modal);
    }
  });
}

function closeAllModals() {
  closeModal($('.modal:not([data-allow-multiple-modals="true"]'));
}
function closeModal($modalToClose) {
  if ($modalToClose.length > 0) {
    document.body.classList.remove('modal-fix');
    document.body.classList.remove('modal-open');
    $modalToClose.removeClass('show');
    setTimeout(() => {
      $('.btn-close', $modalToClose).off('click');
      $('.veil .underlay').off('click');
      $modalToClose.remove();
      document.querySelector('.modal-backdrop')?.remove();
    }, 300);
    if (useVeil) {
      $.spinner().stop();
    }
  }
}

function handleClickToClose(e) {
  e.preventDefault();
  e.stopPropagation();
  const $modal = e.target.classList.contains('.modal')
    ? $(e.target)
    : $(e.target.closest('.modal'));
  if ($modal) {
    applyScrollFix($modal[0], TUA_BODY_SCROLL_ACTIONS.unlock);
    closeModal($modal); // close button
  }
}

module.exports = {
  init: () => {
    $('body').on('click', '[data-interaction="modal"]', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const element = e.target;

      createModalData(element);
    });

    // Used only for paypal method for billing address vertex error
    $('body').on('modals:create-custom-modal', (event, data) => {
      createCustomModal(data.htmlCode, data.modalOptions, data.includeAssets);
    });
  },

  createCustomModal,
  closeModal,

  destroy: () => {
    $('body').off('click', '[data-interaction="modal"]');
  },

  fixFadeBackdrop,
};
